var _clipPath, _filter, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSantainline = function SvgSantainline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 577,
    viewBox: "1000 0 1000 290"
  }, props), /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "santa_inline_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h289v289H0z"
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "santa_inline_svg__a",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "santa_inline_svg__d"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#santa_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h289v289H0z",
    style: {
      fill: "#000",
      fillOpacity: 0.913725,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "santa_inline_svg__c",
    clipPath: "url(#santa_inline_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.438-.25h5.007c1.88 1.21 3.215 2.883 4.008 5.008C125.578.977 134.093-.273 142.996 1a943.052 943.052 0 0 1 40.57 12.023 41.736 41.736 0 0 1 6.762 3.254c1.457-4.836 3.879-9.093 7.266-12.77 4.531-2.89 8.285-2.14 11.27 2.255a12.792 12.792 0 0 1-.505 6.508 602.368 602.368 0 0 0-7.261 14.777c5 5.805 7.754 12.566 8.265 20.285 1.512 1.352 2.512 3.023 3.004 5.008 1.606 4.437 1.938 8.945 1.004 13.523a7.936 7.936 0 0 1-1.254 2.004c9.149 18.332 7.645 35.695-4.508 52.09 17.36 16.277 30.465 35.477 39.317 57.602 4.836 14.011 5.504 28.203 2.004 42.57-6.813 16.476-19.082 23.402-36.813 20.789-7.617-1.508-14.629-4.43-21.035-8.766l-6.012 5.508a394.175 394.175 0 0 0 1.254 36.563 195.35 195.35 0 0 1 8.012 10.52c.234 1.859-.516 3.195-2.254 4.007h-5.508a250.387 250.387 0 0 1-10.27-9.016 11.48 11.48 0 0 0-1-2.504 3372.865 3372.865 0 0 0-2.503-32.054c-12.961 5.637-26.399 7.054-40.32 4.254a50.192 50.192 0 0 1-11.02-3.754 6529.194 6529.194 0 0 0-2.754 32.554c-.754 1.086-1.504 2.172-2.254 3.258a62.83 62.83 0 0 1-9.016 7.262h-5.511c-.406-.672-.992-1.172-1.754-1.504a4.654 4.654 0 0 1 0-3.004c2.504-3.172 5.012-6.344 7.516-9.515a716.724 716.724 0 0 0 2.003-37.067 260.265 260.265 0 0 1-10.77-11.02c-6.429 5.223-13.609 9.145-21.538 11.774-19.883 4.207-32.824-3.39-38.817-22.789-2.894-16.867-.722-33.062 6.512-48.586 5.8-12.445 12.98-23.965 21.54-34.559a512.99 512.99 0 0 1 22.788-24.042c-3.957-9.977-4.543-20.16-1.754-30.555a76.945 76.945 0 0 1 4.758-12.27 46.978 46.978 0 0 1-1.504-6.261 701.328 701.328 0 0 0-14.773 16.53c.36 1.563 1.027 3.067 2.004 4.509.73 3.488.062 6.66-2.004 9.515a32.632 32.632 0 0 1-6.762 6.762c-5.062 2.836-10.07 2.668-15.027-.5-2.813-3.25-3.73-7.008-2.754-11.27 1.535-6.964 5.793-11.136 12.773-12.523a317.168 317.168 0 0 1 18.782-28.047 206.8 206.8 0 0 1 15.023-26.547l4.008-4.008a32.82 32.82 0 0 1 1.504-9.515c1.203-1.957 2.789-3.461 4.757-4.508m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#050504",
      fillOpacity: 1
    }
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#santa_inline_svg__c",
    mask: "url(#santa_inline_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.945 38.816c-1.55-11.52-3.05-23.039-4.507-34.558a8.669 8.669 0 0 1 .5-2.504c3.878-1.566 6.132-.23 6.761 4.008 0 11.043.418 22.062 1.254 33.054h-4.008m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#3c3d3d",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.938 1.754a8.669 8.669 0 0 0-.5 2.504c1.457 11.52 2.957 23.039 4.507 34.558a37.687 37.687 0 0 1-5.007.5 130.329 130.329 0 0 1-4.008-26.293c-.73-4.316.437-7.988 3.507-11.02a2.46 2.46 0 0 1 1.5-.25m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#1a1a1a",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.57 33.809a214.677 214.677 0 0 0-54.843-7.512 260.9 260.9 0 0 0-13.774.5c-.168-6.856 0-13.7.5-20.535 8.438-3.844 17.29-5.098 26.547-3.758a1465.227 1465.227 0 0 1 29.05 8.516 163.068 163.068 0 0 1 16.028 6.011c.535.367.871.867 1 1.5a152.067 152.067 0 0 0-4.508 15.278m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#e62c32",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.598 3.758a128.937 128.937 0 0 0-.75 10.015 573.769 573.769 0 0 1-8.516 25.543c-.32.887-.238 1.72.25 2.508a19.138 19.138 0 0 0-6.012-1.004 135.1 135.1 0 0 1 7.262-27.047 48.777 48.777 0 0 1 4.008-7.511 9.297 9.297 0 0 1 3.758-2.504m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#191919",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.582 41.824c-.488-.789-.57-1.62-.25-2.508a573.769 573.769 0 0 0 8.516-25.543c.12-3.363.37-6.703.75-10.015 5.257-1.004 7.511 1.168 6.761 6.512-3.16 6.656-6.336 13.335-9.515 20.03a51.517 51.517 0 0 0-3.758 11.524h-2.504m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#3d3e3e",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.93 26.297a3.553 3.553 0 0 1-.5 2.504 31.305 31.305 0 0 0-6.512 2.754c-2.207 3.168-5.047 5.09-8.516 5.761a131.574 131.574 0 0 1 8.266-15.027 30.082 30.082 0 0 1 6.008-7.012 158.2 158.2 0 0 1 1.254 11.02m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#e12b31",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.57 33.809a34.17 34.17 0 0 0-1 6.511c-6.332-.804-12.68-1.558-19.035-2.254a295.565 295.565 0 0 0-24.543.25h-22.539c.121-.648-.047-1.148-.5-1.504a43.096 43.096 0 0 1-1-10.015 260.9 260.9 0 0 1 13.774-.5 214.677 214.677 0 0 1 54.843 7.512m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#c8212d",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.93 26.297a404.813 404.813 0 0 1 3.004 13.523c-9.684 1.586-14.942 7.262-15.778 17.028L74.88 75.128a51.055 51.055 0 0 0-9.016-1.753 13.105 13.105 0 0 1 2.254-5.008 435.84 435.84 0 0 1 16.028-23.039 89.886 89.886 0 0 1 4.257-8.012c3.47-.671 6.309-2.593 8.516-5.761a31.305 31.305 0 0 1 6.512-2.754c.476-.774.644-1.61.5-2.504m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#c6212d",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.61 40.82a101.578 101.578 0 0 0-9.27-3.004c-.516-.168-.766-.504-.75-1.004a45.86 45.86 0 0 1 3.258-8.511c3.566 3.46 5.82 7.637 6.761 12.52m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#e02b31",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.59 36.813c-.016.5.234.835.75 1.003 3.344.918 6.43 1.922 9.27 3.004.788 1.692 1.124 3.528 1 5.512a195.556 195.556 0 0 1-13.024-4.508 42.945 42.945 0 0 1 2.004-5.011m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#c1202b",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.953 36.813c.453.355.621.855.5 1.503h22.54c-7.59.5-15.27.664-23.04.5v-2.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#91161f",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5 38.816c19.941-.668 39.477 1.754 58.602 7.262 5.394 2.008 8.148 5.93 8.265 11.774a24.518 24.518 0 0 1 0 7.011c-.445 2.016-1.695 3.016-3.758 3.004a107.968 107.968 0 0 1-9.515-3.254 37.168 37.168 0 0 0-6.008-1.004 1327.82 1327.82 0 0 1-30.555 0 138.549 138.549 0 0 0-37.566-1.5 615.095 615.095 0 0 0-26.043 4.004c-4.18.836-6.266-.918-6.262-5.258-1.644-8.144 1.11-14.238 8.266-18.28a27.635 27.635 0 0 1 10.015-2.505c11.61-.16 23.13-.578 34.559-1.254m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#fcfcfc",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.04 100.422c-.532 1.117-.45 2.285.25 3.508 1.753 3.765 4.675 6.187 8.765 7.261 14.582 1.516 24.851-4.41 30.8-17.78 1.23-4.247 1.567-8.587 1.004-13.02-.195-1.555-.78-2.891-1.754-4.008-2.207-6.457-6.714-10.383-13.523-11.77 5.25.301 10.258 1.637 15.027 4.004 1.63.11 3.215.36 4.758.754 6 11.895 6.754 24.082 2.254 36.563-5.012 8.363-12.191 14.12-21.539 17.28-13.508 4.45-27.363 6.122-41.57 5.009-15.492-.325-30.02-4.164-43.578-11.52-16.172-10.824-21.348-25.601-15.528-44.328.39-2.113 1.309-3.95 2.758-5.508.98.274 1.98.442 3.004.5a59.7 59.7 0 0 1 11.27-1.254c-1.731 1.633-2.899 3.551-3.508 5.762-.153-.621-.403-.621-.75 0-2.282 5.645-2.282 11.32 0 17.027 5.675 12.024 14.941 19.621 27.797 22.79 6.18.812 12.023-.188 17.53-3.004 3.169-2.43 4.505-5.516 4.009-9.266 1.113-4.633.359-8.973-2.254-13.024-6.684-9.98-15.45-17.578-26.297-22.789a55.377 55.377 0 0 1 13.523-1.25c11.227.57 22.414 1.57 33.559 3.004a73.916 73.916 0 0 1 13.523-.75c-5.59 3.418-10.011 8.012-13.273 13.774a51.928 51.928 0 0 0-6.008 15.023 48.899 48.899 0 0 0-.25 7.012m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#2c2c2c",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.04 100.422c-.15-1.117.019-2.121.5-3.004 1.612 5.371 5.202 8.21 10.769 8.516 13.472-1.954 21.07-9.72 22.789-23.29-.621-6.835-3.375-12.43-8.266-16.78 9.422 3.64 13.262 10.484 11.523 20.534-2.363 11.512-9.125 18.942-20.285 22.29-5.78 1.289-10.875.039-15.277-3.758a12.984 12.984 0 0 1-1.754-4.508m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#00f0b6",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.945 64.863a2.466 2.466 0 0 1 1.5.25c-4.238 2.364-5.992 5.953-5.257 10.77 3.921 16.695 14.359 26.379 31.304 29.047 7.215-.282 11.637-3.953 13.274-11.016.683 8-2.907 12.926-10.77 14.773-17.984-.519-29.922-9.285-35.812-26.296-1.23-4.48-.899-8.82 1-13.02 1.207-1.957 2.793-3.46 4.761-4.508m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#00f0b7",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.078 70.371c2.766.274 3.434 1.524 2.004 3.758-3.156.246-3.824-1.004-2.004-3.758m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#bfbfbf",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.957 71.875c3.258-.184 4.094 1.07 2.504 3.754-2.863.203-3.695-1.05-2.504-3.754m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#bcbcbc",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.93 71.875c-.758 15.262 5.59 26.531 19.035 33.809 6.144 3.367 12.656 4.535 19.535 3.504 5.242-1.32 8.582-4.579 10.016-9.766.496 3.75-.84 6.836-4.008 9.266-5.508 2.816-11.352 3.816-17.531 3.003-12.856-3.168-22.122-10.765-27.797-22.789-2.282-5.707-2.282-11.382 0-17.027.347-.621.597-.621.75 0m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#575758",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.355 74.379c4.438-.55 8.614.2 12.524 2.254 2.812 2.488 3.73 5.578 2.754 9.265a32.45 32.45 0 0 1-8.266 9.766c-4.418 2.387-8.758 2.219-13.02-.5-1.976-2-2.812-4.422-2.507-7.262.195-6.238 3.031-10.746 8.515-13.523m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#fbfbfb",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.406 72.375c-5.82 18.727-.644 33.504 15.528 44.328 13.558 7.356 28.086 11.195 43.578 11.52 14.207 1.113 28.062-.559 41.57-5.008 9.348-3.16 16.527-8.918 21.54-17.281-2.513 6.77-6.352 12.699-11.52 17.78-13.942 12.161-30.22 18.087-48.836 17.782-17.368.387-33.145-4.371-47.332-14.277-17.887-14.871-22.73-33.153-14.528-54.844m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#1d1d1d",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.105 76.383c.973 1.117 1.56 2.453 1.754 4.008.563 4.433.227 8.773-1.004 13.02-5.949 13.37-16.218 19.296-30.8 17.78-4.09-1.074-7.012-3.496-8.766-7.261-.7-1.223-.781-2.39-.25-3.508.93 5.324 4.102 8.41 9.516 9.27 12.664 1.222 21.761-3.872 27.297-15.278 2.652-5.773 3.402-11.785 2.253-18.031m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#555556",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54 97.418c-.481.883-.65 1.887-.5 3.004-.653-1.262-.653-2.598 0-4.004.398.227.565.562.5 1m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#007356",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41 113.945a102.694 102.694 0 0 0-11.52 17.532c-4.18.53-8.35 1.03-12.523 1.503a282.522 282.522 0 0 1 21.79-23.039 24.037 24.037 0 0 1 2.253 4.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#66b7fb",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41 113.945a30.767 30.767 0 0 1 3.004 4.508 67.38 67.38 0 0 0-7.512 12.024c-2.336.332-4.675.668-7.011 1 3.25-6.25 7.09-12.094 11.52-17.532m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#41a7ec",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.602 131.977a129.473 129.473 0 0 1-9.016 10.02c-.86-1.013-1.86-1.177-3.004-.5a57.024 57.024 0 0 0-.75 7.51 169.265 169.265 0 0 1-1.004-9.515c-.586-1.605-1.672-2.355-3.254-2.254a4.679 4.679 0 0 0-.754 1.25 72.906 72.906 0 0 0-.25 8.516c-12.824 5.383-26.18 7.305-40.07 5.762A127.967 127.967 0 0 1 112.445 144c1.106-2.398 1.524-4.902 1.25-7.516-.918-1.68-2.004-1.847-3.254-.5a45.455 45.455 0 0 0-2.254 6.012c-.167-1.504-.335-3.004-.5-4.508-1.058-1.215-2.062-1.215-3.007 0a12.219 12.219 0 0 1-.75 3.504 2.42 2.42 0 0 0-.5-2 194.913 194.913 0 0 1-13.524-9.52 26.65 26.65 0 0 1 6.512-10.015c10.102 11.23 22.621 18.328 37.562 21.285 19.551 4.317 38.25 1.98 56.098-7.012a90.023 90.023 0 0 0 10.52-7.261 14.75 14.75 0 0 1 3.004 5.508m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#eac40c",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.125 130.977a26.306 26.306 0 0 1-6.512-.5 91.31 91.31 0 0 0-5.008-7.516c.41-1.285 1.247-1.871 2.504-1.75a251.16 251.16 0 0 0 9.016 9.766m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#64b3f6",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.605 122.96a91.31 91.31 0 0 1 5.008 7.517c-1.773-.157-3.445.007-5.008.5a43.28 43.28 0 0 1-3.007-5.508 930.364 930.364 0 0 1 3.007-2.508m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#2497de",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.906 129.473a194.913 194.913 0 0 0 13.524 9.52 2.42 2.42 0 0 1 .5 2 308.59 308.59 0 0 1-3.004 17.03 49.263 49.263 0 0 1-10.02-6.511 6.445 6.445 0 0 1 1.504-3.004c-.062-.305-.23-.473-.5-.5a98.032 98.032 0 0 0-2.004-8.516 31.759 31.759 0 0 0-2.004-6.012 11.346 11.346 0 0 1 2.004-4.007m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#f1d601",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.613 130.477c2.137.437 4.309.601 6.512.5.703.238 1.04.738 1 1.503a27.605 27.605 0 0 1-6.008-.503 30.508 30.508 0 0 1-6.512-.5v-.5c1.563-.493 3.235-.657 5.008-.5m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#cfe3f2",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.902 130.477a2.855 2.855 0 0 1-.5 1.5c-6.664.82-13.34 1.488-20.035 2.003.168-.5.5-.832 1-1 4.172-.472 8.344-.972 12.524-1.503 2.336-.332 4.675-.668 7.011-1m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#d2e4f3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.605 131.477c2.145.398 4.317.566 6.512.5a115.33 115.33 0 0 1 9.516 19.285c-1.832.25-3.668.332-5.512.25a187.085 187.085 0 0 0-6.762-11.02 108.128 108.128 0 0 0-3.754-9.015m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#1c97df",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.602 131.977a17.764 17.764 0 0 1 2.003 3.507c-.347.512-.68 1.012-1 1.504a27.088 27.088 0 0 1-1.003 3.504c-1.168 3.684-2.34 7.356-3.504 11.02a12.46 12.46 0 0 0 2.504 4.008c.043.5-.125.914-.5 1.25a39.39 39.39 0 0 1-7.516 3.757v-18.53a129.473 129.473 0 0 0 9.016-10.02m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#ecd101",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.117 131.977c1.977.386 3.98.554 6.008.503a106.429 106.429 0 0 1 15.027 19.532h-16.527c-.336 0-.504-.164-.504-.5 1.844.082 3.68 0 5.512-.25a115.33 115.33 0 0 0-9.516-19.285m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#67b7fb",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.402 131.977a116.489 116.489 0 0 0-12.023 19.535 148.09 148.09 0 0 1-21.535 2.004 131.408 131.408 0 0 1 13.523-19.536 441.283 441.283 0 0 0 20.035-2.003m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#61b5fa",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.902 133.48a31.759 31.759 0 0 1 2.004 6.012 149.571 149.571 0 0 0-11.77 19.531 56.274 56.274 0 0 0-3.757 18.032c.957.144 1.793-.024 2.504-.5a15.258 15.258 0 0 0 6.012-2.254 262.893 262.893 0 0 0 16.277-10.77 29.441 29.441 0 0 0 2.504-4.508 291.487 291.487 0 0 1 4.508-21.535c.55.98.8 2.067.75 3.254a117.352 117.352 0 0 1-1.5 12.274c-.774 4.382-2.524 8.39-5.262 12.02-5.758 4.089-11.52 8.179-17.277 12.273-1.77 1.464-3.106 3.218-4.008 5.257-2.211 1.774-4.715 2.692-7.512 2.754-3.102-2.953-4.187-6.543-3.258-10.77 3.817-15.14 10.41-28.831 19.785-41.07m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#4e4e4e",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.887 182.566c.902-2.039 2.238-3.793 4.008-5.257 5.757-4.094 11.52-8.184 17.277-12.274 2.738-3.629 4.488-7.637 5.262-12.02.398 1.329.73 1.243 1-.25a74.636 74.636 0 0 1 5.007-16.027c.477-.312.895-.226 1.254.25a6.287 6.287 0 0 1 0 3.504 200.065 200.065 0 0 0-5.257 17.031c.113.715.449.965 1 .75a31.811 31.811 0 0 0 4.507-5.007c.5-.336 1-.336 1.504 0a29.582 29.582 0 0 1-3.258 5.757 74.06 74.06 0 0 1-10.77 9.77 364.196 364.196 0 0 1-21.534 13.773m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#2c2c2c",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.605 136.988a131.206 131.206 0 0 1 10.266 16.028 286.616 286.616 0 0 1 8.516 21.035c1.418 5.258-.5 7.18-5.762 5.762-.7-.208-1.367-.458-2-.754a812.947 812.947 0 0 1-23.043-13.774 6.533 6.533 0 0 0-2.504-.25 7.272 7.272 0 0 1-4.008-1.754 53.437 53.437 0 0 0-6.257-5.758 5.105 5.105 0 0 1-.754-2.003c.117-.72.453-.97 1.004-.75a24.684 24.684 0 0 0 6.007 5.757c.493-.238.91-.57 1.254-1a93.022 93.022 0 0 0-.75-16.28 15.871 15.871 0 0 1 .75-5.259c.5.5 1 1.004 1.504 1.504.61 5.332 1.11 10.672 1.5 16.028.156.402.406.738.754 1 .39-.614.64-1.282.75-2.004.086-4.184.336-8.356.75-12.52.293.106.547.274.754.5a238.61 238.61 0 0 0 1 21.035c5.758 5.008 12.351 8.348 19.785 10.02 1.219.09 2.305-.242 3.254-1.004.305-1.871.14-3.707-.5-5.508a72.561 72.561 0 0 0-10.016-17.031c-1.613-3.055-2.699-6.227-3.257-9.516.41-1.137.746-2.304 1.003-3.504m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#4e4e4e",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.906 139.492c.793 2.801 1.461 5.64 2.004 8.516-5.672 6.949-10.265 14.629-13.773 23.039a14.396 14.396 0 0 0-1.254 5.508c-.711.476-1.547.644-2.504.5a56.274 56.274 0 0 1 3.758-18.032 149.571 149.571 0 0 1 11.77-19.53M203.602 140.492c.558 3.29 1.644 6.461 3.257 9.516a72.561 72.561 0 0 1 10.016 17.031c.64 1.8.805 3.637.5 5.508-.95.762-2.035 1.094-3.254 1.004 1.227-1.406 1.313-2.906.25-4.508a104.43 104.43 0 0 0-14.273-17.531c1.164-3.664 2.336-7.336 3.504-11.02m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#2d2d2d",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.445 144a127.967 127.967 0 0 0 33.055 8.766c13.89 1.543 27.246-.38 40.07-5.762.715 3.742.965 7.582.754 11.52-.168.167-.336.335-.504.5a43.14 43.14 0 0 1-5.757-5.258c-1.368-.473-2.036.03-2.004 1.504 1.847 3.437 4.351 6.359 7.511 8.765a1.129 1.129 0 0 1-.5.75c-25.652 9.563-51.03 8.977-76.132-1.754 2.96-2.8 5.132-6.136 6.511-10.015-.773-.977-1.773-1.227-3.004-.754a13.562 13.562 0 0 1-2.754 3.258 55.097 55.097 0 0 1 2.754-11.52m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#f3d701",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.906 151.512a49.263 49.263 0 0 0 10.02 6.511c-.824 2.559-2.328 4.645-4.508 6.262a213.414 213.414 0 0 1-14.777 9.266 28.448 28.448 0 0 1 0-7.512 81.263 81.263 0 0 1 9.265-14.527m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#292928",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.625 152.012h16.527c.703.238 1.04.738 1 1.504-4.011-.07-8.02-.239-12.02-.5h-5.007c-.422-.172-.59-.504-.5-1.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#d5e6f4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.379 151.512c-.078.828-.414 1.496-1 2.004-6.184.37-12.36.87-18.531 1.504-.938-.004-1.774-.172-2.504-.504.164-.332.332-.664.5-1a148.09 148.09 0 0 0 21.535-2.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#d5e7f5",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.125 153.016h5.008c2.547 7.043 3.715 14.222 3.504 21.535a840.947 840.947 0 0 0-8.512-21.535m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#1c96de",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.133 153.016c4 .261 8.008.43 12.02.5a101.24 101.24 0 0 1 12.023 24.043 634.856 634.856 0 0 0-20.54-2.504v-.504c.212-7.313-.956-14.492-3.503-21.535m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#68b9fd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.379 153.516a134.83 134.83 0 0 0-7.512 21.035 786.85 786.85 0 0 0-24.543 4.008 98.049 98.049 0 0 1 11.02-24.043c.73.332 1.566.5 2.504.504a440.153 440.153 0 0 1 18.53-1.504m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#66b8fc",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.602 155.52a257.756 257.756 0 0 0 8.765 11.02c.668 1.765.918 3.6.75 5.507a48.013 48.013 0 0 1-16.777-9.016 4.387 4.387 0 0 1-.754-2.504 39.39 39.39 0 0 0 7.516-3.757 1.43 1.43 0 0 0 .5-1.25m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#2c2c2c",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.938 163.031c25.101 10.73 50.48 11.317 76.132 1.754.278-.191.446-.441.5-.75a443.388 443.388 0 0 1 15.028 10.766 49.14 49.14 0 0 0 11.02 4.258c-.778 9.402-2.95 18.418-6.513 27.046-17.144 7.125-35.175 11.383-54.093 12.774-6.848.332-13.692.332-20.535 0a64.367 64.367 0 0 1-13.524-2.254c-8.683-8.418-16.113-18.102-22.289-29.05a58.4 58.4 0 0 1-4.258-10.52 186.047 186.047 0 0 0 18.531-14.024m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#2d2d2c",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.078 165.035a6.533 6.533 0 0 1 2.504.25 812.947 812.947 0 0 0 23.043 13.774c-9.96-2.13-18.477-6.805-25.547-14.024m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#2c2c2c",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.887 169.543c.574 1.574.656 3.242.25 5.008-.719.758-1.469.926-2.254.504.672-1.852 1.34-3.688 2.004-5.512m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#3995d3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.574 173.55c5.188-.605 9.61.895 13.274 4.509 2.547 5.574 2.047 10.914-1.504 16.027-5.219 7.082-11.98 12.176-20.285 15.277-23.293 8.313-44.829 5.137-64.61-9.515-4.601-3.934-8.027-8.692-10.27-14.278-1.374-4.68.212-7.765 4.758-9.265a78.85 78.85 0 0 1 12.524 0 1187.54 1187.54 0 0 0 39.066 2.754c4.36-.25 8.7-.668 13.024-1.25a75.338 75.338 0 0 1 14.023-4.258m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#373737",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.867 174.55v1.005a1397.18 1397.18 0 0 1-23.043 4.007c-.613-.011-1.113-.18-1.5-.503v-.5a786.85 786.85 0 0 1 24.543-4.008m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#d5e8f7",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.637 175.055a634.856 634.856 0 0 1 20.539 2.504c.453.355.617.855.5 1.5-7.02-1-14.031-2.004-21.04-3.004v-1m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#d4e6f5",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.867 175.555v3.004a818.7 818.7 0 0 1-11.02 12.773 308.006 308.006 0 0 1-17.03 3.754c.425-5.563 1.593-10.902 3.507-16.027.387.324.887.492 1.5.504a1397.18 1397.18 0 0 0 23.043-4.008m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#68b9fd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.637 176.055c7.008 1 14.02 2.004 21.039 3.004a76.065 76.065 0 0 1 4.008 15.527c-5.34-.75-10.684-1.5-16.032-2.254-1-.5-2-1-3.004-1.5a235.084 235.084 0 0 1-8.515-9.77c2.137-.925 2.969-2.597 2.504-5.007m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#66b7fc",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.406 177.055a58.4 58.4 0 0 0 4.258 10.52c6.176 10.948 13.606 20.632 22.29 29.05-10.227-1.906-19.743-5.578-28.552-11.02-.332 0-.5.168-.5.5-3.175-7.597-5.175-15.527-6.011-23.789a132.44 132.44 0 0 1 8.515-5.261m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#1e1e1e",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.633 181.063a1453.4 1453.4 0 0 1 4.004 5.511c-.414 6.328-1.914 12.34-4.508 18.031a74.75 74.75 0 0 0-10.016-10.52 69.778 69.778 0 0 0 2.504-14.023c2.672.333 5.344.668 8.016 1m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#1e99e1",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.867 180.063c.5 1.332 1 2.667 1.5 4.007a175.807 175.807 0 0 0 2.004 15.024 672.299 672.299 0 0 1-14.023 17.281 65.942 65.942 0 0 1-14.524 4.258c-3.308-8.133-4.308-16.48-3.008-25.043.301.32.72.484 1.254.5a884.135 884.135 0 0 0 14.274-2.754c1.004-.504 2.004-1.004 3.004-1.504a299.331 299.331 0 0 0 9.52-11.77m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#68b9fd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.637 186.574a28.938 28.938 0 0 1 4.508 4.758l2.507 1.5a120.603 120.603 0 0 0 18.032 2.758 67.899 67.899 0 0 1-.254 17.027c-.39 3.074-1.309 5.914-2.754 8.516a93.707 93.707 0 0 1-15.024-3.758 410.842 410.842 0 0 1-11.523-12.77c2.594-5.69 4.094-11.703 4.508-18.03m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#67b9fd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.633 181.063h1.5a235.084 235.084 0 0 0 8.515 9.769c1.004.5 2.004 1 3.004 1.5 5.348.754 10.692 1.504 16.032 2.254v1.004a120.603 120.603 0 0 1-18.032-2.758l-2.507-1.5a28.938 28.938 0 0 0-4.508-4.758 1453.4 1453.4 0 0 0-4.004-5.512m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#d4e6f5",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.867 178.559v1.504a299.331 299.331 0 0 1-9.52 11.769c-1 .5-2 1-3.003 1.504-4.75.957-9.508 1.875-14.274 2.754-.535-.016-.953-.18-1.254-.5v-.504a308.006 308.006 0 0 0 17.032-3.754 818.7 818.7 0 0 0 11.02-12.773m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#d5e8f6",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.898 207.11a165.104 165.104 0 0 0-7.761 7.511 14.963 14.963 0 0 0-1.754 4.508 22.389 22.389 0 0 1-3.254-5.508 166.963 166.963 0 0 1-3.758-12.023 66.886 66.886 0 0 1 11.02-12.77l-.25-.754c-.711.48-1.461.899-2.254 1.254a227.21 227.21 0 0 0-8.516 9.766 175.807 175.807 0 0 1-2.004-15.024c1.063 1.215 2.399 2.051 4.008 2.504a27.214 27.214 0 0 0 8.266-4.008 105.407 105.407 0 0 0 6.257 24.543m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#44a9ee",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.113 195.59a141.998 141.998 0 0 1 9.516 10.515 63.627 63.627 0 0 1-6.762 13.524c-.406.664-.992.996-1.75 1.004-2.672-2.504-5.344-5.008-8.015-7.516a142.436 142.436 0 0 0 7.011-17.527m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#2199e1",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.371 201.598a166.963 166.963 0 0 0 3.758 12.023 22.389 22.389 0 0 0 3.254 5.508 437.856 437.856 0 0 0-.5 15.527h1.504a85.803 85.803 0 0 1 .5-12.523 33.966 33.966 0 0 0 10.52 9.015c-10.169 7.301-21.188 8.97-33.06 5.012a757.86 757.86 0 0 1 1.255-19.035 599.613 599.613 0 0 1 12.77-15.527m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#68b9fd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.902 206.61a17.735 17.735 0 0 0 2.004 3.503 38.901 38.901 0 0 1 3.504 6.512c-.45-.504-.781-.504-1 0a108.617 108.617 0 0 1-5.008-8.516v-1c0-.336.164-.5.5-.5m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#1d2b35",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.402 205.605c8.809 5.442 18.325 9.114 28.551 11.02a64.367 64.367 0 0 0 13.524 2.254c6.843.332 13.687.332 20.535 0 18.918-1.39 36.949-5.649 54.093-12.774-2.066 5.81-4.906 11.153-8.515 16.028a77.826 77.826 0 0 0-6.512 4.258 37.107 37.107 0 0 1-7.512 3.257c-1.414-.8-2.914-1.05-4.507-.753-2.332 1.242-4.336 2.828-6.012 4.757-16.73 3.477-33.426 3.309-50.086-.5a26.475 26.475 0 0 0-5.508-4.257 7.147 7.147 0 0 0-4.008.25c-.851.082-1.687 0-2.504-.25a111.827 111.827 0 0 1-12.523-6.762 51.345 51.345 0 0 1-4.008-5.508 38.901 38.901 0 0 0-3.504-6.512c-.36-1.55-.86-3.05-1.504-4.508m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#f3d701",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.629 206.105a142.25 142.25 0 0 1 10.77 12.524 281.87 281.87 0 0 1 1.253 19.031c-5.855 2.45-11.867 3.117-18.03 2.004.081-4.676 0-9.351-.25-14.023a11.484 11.484 0 0 0-2.255-5.008c.758-.008 1.344-.34 1.75-1.004a63.627 63.627 0 0 0 6.762-13.524m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#68b9fe",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.402 205.605a25.133 25.133 0 0 1 1.504 4.508 17.735 17.735 0 0 1-2.004-3.504v-.504c0-.332.168-.5.5-.5m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#84adc2",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.402 208.11a108.617 108.617 0 0 0 5.008 8.515 73.403 73.403 0 0 0 5.508 8.266 30.662 30.662 0 0 1-8.512 6.257 33.966 33.966 0 0 1-10.52-9.015c-.175-2.07.075-4.074.75-6.008a58.638 58.638 0 0 1 7.766-8.016m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#42a8ee",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.898 207.11h.504v1a58.638 58.638 0 0 0-7.765 8.015 14.337 14.337 0 0 0-.75 6.008 85.803 85.803 0 0 0-.5 12.523h-1.504c.074-5.18.242-10.355.5-15.527.336-1.59.922-3.09 1.754-4.508 2.523-2.605 5.11-5.11 7.761-7.512m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#d5e7f5",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.602 214.121a48.03 48.03 0 0 1 8.011 8.516 76.838 76.838 0 0 1-11.52 11.77c.278.19.446.44.5.75a21.269 21.269 0 0 1-5.507-2.755c-.914-.449-1.582-1.117-2.004-2.004a75.953 75.953 0 0 0 10.52-16.277m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#1e98e0",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.113 194.086a74.75 74.75 0 0 1 10.016 10.52 410.842 410.842 0 0 0 11.523 12.769 93.707 93.707 0 0 0 15.024 3.758v1a58.365 58.365 0 0 1-14.024-3.004c-.27 6-.27 12.008 0 18.031-.332.168-.668.336-1 .5a281.87 281.87 0 0 0-1.254-19.031 142.25 142.25 0 0 0-10.77-12.524c-3-3.667-6.171-7.171-9.515-10.515v-1.504m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#d5e8f6",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.371 201.598a599.613 599.613 0 0 0-12.77 15.527 757.86 757.86 0 0 0-1.253 19.035c-.336-.168-.668-.336-1-.504a624.6 624.6 0 0 0 .25-17.527 60.115 60.115 0 0 1-13.274 3.504 119.22 119.22 0 0 1-.5-1 65.942 65.942 0 0 0 14.524-4.258 672.299 672.299 0 0 0 14.023-17.281 227.21 227.21 0 0 1 8.516-9.766 14.899 14.899 0 0 0 2.254-1.254l.25.754a66.886 66.886 0 0 0-11.02 12.77m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#d6e8f6",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.348 235.656c-5.899-3.226-10.243-7.898-13.024-14.023 4.578-.664 9-1.836 13.274-3.504a624.6 624.6 0 0 1-.25 17.527m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#67b8fc",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.676 222.133c-2.856 6.726-7.531 11.734-14.024 15.027-.27-6.023-.27-12.031 0-18.031a58.365 58.365 0 0 0 14.024 3.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#67b7fb",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.613 222.637c.532.55.95 1.218 1.254 2 .418 5.004.668 10.011.75 15.027-4.656-.719-9-2.219-13.023-4.508a1.129 1.129 0 0 0-.5-.75 76.838 76.838 0 0 0 11.52-11.77m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#67b8fb",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.418 222.133c3.988 2.496 8.16 4.75 12.523 6.762.817.25 1.653.332 2.504.25a9.762 9.762 0 0 1-1.754 2.003 26.503 26.503 0 0 1-.75 5.012 124.071 124.071 0 0 1-12.523-14.027m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#d7a41d",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.59 222.133c-3.219 5.484-7.313 10.328-12.27 14.527a31.309 31.309 0 0 0-1.754-7.012c2.606-.8 5.11-1.886 7.512-3.257a77.826 77.826 0 0 1 6.512-4.258m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#daa51e",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.102 213.117c2.671 2.508 5.343 5.012 8.015 7.516a11.484 11.484 0 0 1 2.254 5.008c.25 4.672.332 9.347.25 14.023h-1.004a224.581 224.581 0 0 0-.75-15.027 5.964 5.964 0 0 0-1.254-2 48.03 48.03 0 0 0-8.011-8.516c.164-.336.332-.668.5-1.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#daeaf6",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.953 231.148a18.926 18.926 0 0 0-1.754 5.512 1032.128 1032.128 0 0 1-2.504 38.067 73.073 73.073 0 0 1-7.761 10.265 8.693 8.693 0 0 1-3.508 1.754c-.574-.144-.906-.562-1-1.254a111.615 111.615 0 0 1 7.761-10.265 8518.286 8518.286 0 0 1 2.504-43.575c1.895-2.5 3.985-2.668 6.262-.504M191.582 286.746c-5.27-3.027-9.027-7.367-11.27-13.023a3425.29 3425.29 0 0 0-2.503-39.067 13.312 13.312 0 0 0-1.754-3.004c1.875-2.43 3.965-2.593 6.261-.504a1201.324 1201.324 0 0 1 2.504 43.579c2.672 3.34 5.344 6.675 8.012 10.015.457 1.227.04 1.895-1.25 2.004m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#3d3e3e",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.055 231.652c.703.903 1.289 1.907 1.754 3.004a3425.29 3425.29 0 0 1 2.504 39.067c2.242 5.656 6 9.996 11.269 13.023-2.508.879-4.844.461-7.012-1.254a50.989 50.989 0 0 0-6.261-5.758 7.702 7.702 0 0 1-1.504-3.004c-.887-11.343-1.723-22.699-2.504-34.062a34.104 34.104 0 0 0-1.25-7.012c.058-2.058 1.058-3.394 3.004-4.004M117.953 231.148c1.942 1.02 2.945 2.606 3.008 4.758a467.027 467.027 0 0 0-3.258 40.32c-.5 1.004-1 2.004-1.504 3.008a101.948 101.948 0 0 1-9.265 7.762c-1.598.402-3.102.32-4.508-.25a8.693 8.693 0 0 0 3.508-1.754 73.073 73.073 0 0 0 7.761-10.265c1.07-12.672 1.903-25.36 2.504-38.067.305-1.937.89-3.773 1.754-5.512m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#1e1e1e",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.96 233.152c16.661 3.809 33.356 3.977 50.087.5a49.997 49.997 0 0 0 1.004 7.766 7.24 7.24 0 0 1-.504 2.504c-8.25 3.851-16.93 5.605-26.043 5.258-8.777.449-17.125-1.22-25.043-5.008-.168-.5-.336-1-.5-1.504a41.897 41.897 0 0 0 1-9.516m0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#dea81f",
      fillOpacity: 1
    }
  }));
};
export default SvgSantainline;